export default [
  {
    path: '/template',
    name: 'template',
    props: true,
    // component: () => import( '@/views/shares/index.vue' ),
    component: {
      render: h => h('router-view')
    },
    meta: {
      title: '加载中...'
    },
    children: [
      {
        path: '1',
        name: 'ming',
        meta: {
           title: '加载中...'
        },
        component: {
          render: h => h('router-view')
        },
        children: [
          {
            path: '',
             name: 'ming_special',
             meta: {
                title: '加载中...'
             },
            component: () => import('@/views/template/ming/special')
                    },
          {
            path: 'index/:id',
            name: 'ming_index',
             meta: {
                title: '加载中...'
             },
            component: () => import('@/views/template/ming/index')
                      },
          {
             path: 'detail/:id',
             name: 'ming_detail',
             meta: {
                title: '加载中...'
             },
             component: () => import('@/views/template/ming/detail')
          },
       ]
      },
   ]
 },
]
